import { WorkplacesTreeItem } from '../../../Manager/Components/WorkplaceManager/ManagerWorkplaceWrapper/ManagerWorkplaceWrapper';
import { WorkplaceType } from '../../../Manager/Enums/WorkplaceType.enum';

export default function findChildrenFoldersIds(
	children: WorkplacesTreeItem[],
): string[] {
	if (children.length === 0) {
		return [];
	}

	return children
		.filter(child => child.type === WorkplaceType.FOLDER)
		.flatMap(child => [child.id, ...findChildrenFoldersIds(child.children)]);
}
